export class SkusLastUpdatedDto {
    constructor(
        public lastUpdated: Date,
        public version: string,
    ) { }
}